export const NETWORKS = [
  {
    network_name: 'ethereum',
    http_provider:
      'https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
    chain_id: 1,
    name: 'Ethereum',
    symbol: 'ETH',
    tx_explorer_url: 'https://etherscan.io/tx/$HASH',
  },
  {
    network_name: 'polygon',
    http_provider:
      'https://polygon-mainnet.infura.io/v3/2343217699c44b45851935789f1f89e6',
    chain_id: 137,
    name: 'Polygon',
    symbol: 'MATIC',
    tx_explorer_url: 'https://polygonscan.com/tx/$HASH',
  },
  {
    network_name: 'xdai',
    http_provider: 'https://dai.poa.network',
    chain_id: 100,
    gas_override: 1000000000,
    symbol: 'xDAI',
    name: 'xDAI',
    web3_info: {
      chainId: '0x64',
      chainName: 'xDAI Chain',
      rpcUrls: ['https://dai.poa.network'],
      iconUrls: [
        'https://xdaichain.com/fake/example/url/xdai.svg',
        'https://xdaichain.com/fake/example/url/xdai.png',
      ],
      nativeCurrency: { name: 'xDAI', symbol: 'xDAI', decimals: 18 },
    },
    tx_explorer_url: 'https://blockscout.com/xdai/mainnet/tx/$HASH',
  },
  {
    network_name: 'bsc',
    http_provider: 'https://bsc-dataseed.binance.org/',
    chain_id: 56,
    name: 'Binance Smart Chain',
    symbol: 'BNB',
    tx_explorer_url: 'https://bscscan.com/tx/$HASH',
  },
  {
    network_name: 'aurora',
    http_provider: 'https://mainnet.aurora.dev',
    chain_id: 1313161554,
    name: 'Aurora',
    symbol: 'aETH',
    gas_override: 0,
  },
  {
    network_name: 'ropsten',
    http_provider:
      'https://ropsten.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
    chain_id: 3,
    name: 'Ropsten (TEST)',
    symbol: 'ROP',
    web3_info: null,
    tx_explorer_url: 'https://ropsten.etherscan.io/tx/$HASH',
  },
  {
    network_name: 'rinkeby',
    http_provider:
      'https://rinkeby.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
    chain_id: 4,
    name: 'Rinkeby (TEST)',
    symbol: 'RIN',
    tx_explorer_url: 'https://rinkeby.etherscan.io/tx/$HASH',
  },
  {
    network_name: 'goerli',
    http_provider:
      'https://goerli.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
    chain_id: 5,
    name: 'Goerli (TEST)',
    symbol: 'GOE',
    tx_explorer_url: 'https://goerli.etherscan.io/tx/$HASH',
  },
  {
    network_name: 'sokol',
    http_provider: 'https://sokol.poa.network',
    chain_id: 77,
    name: 'Sokol (TEST)',
    symbol: 'SOKOL',
    web3_info: null,
    tx_explorer_url: 'https://blockscout.com/poa/sokol/tx/$HASH',
  },
  {
    network_name: 'kovan',
    http_provider:
      'https://kovan.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
    chain_id: 42,
    name: 'Kovan (TEST)',
    symbol: 'KOV',
    web3_info: null,
    tx_explorer_url: 'https://kovan.etherscan.io/tx/$HASH',
  },
  {
    network_name: 'aurora_testnet',
    http_provider: 'https://testnet.aurora.dev',
    chain_id: 1313161555,
    gas_override: 0,
    name: 'Aurora (TEST)',
    symbol: 'atETH',
  },
];
